export const checkValuesChanged = (formValues, initialFormValues) => {
    if (!formValues || !initialFormValues) {
        return false;
    }

    return (
        formValues.vin !== initialFormValues.vin ||
        formValues.language !== initialFormValues.language ||
        formValues.model !== initialFormValues.model
    );
};

export const handleFormValuesChange = (allValues, initialFormValues, onHasUnsavedChanges) => {
    if (Object.keys(initialFormValues || {}).length === 0) {
        return;
    }

    const isValuesChanged = checkValuesChanged(allValues, initialFormValues);
    onHasUnsavedChanges(isValuesChanged);
};
